/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waitlist_LabelInputs */



/**
* | output |
* | --- |
* | "Waitlist" |
*
* @param {Waitlist_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const waitlist_label = /** @type {((inputs?: Waitlist_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waitlist_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste d'attente")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista de espera")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Lista de espera")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lista d'attesa")
	return /** @type {LocalizedString} */ ("Waitlist")
});